var messages = {
  emptyText: '列表放空中～',
  clickToDrag: '点击可拖动',
  validationTableName: '表格数据行',
  validationError: '有 $count 个$table_name保存失败。',
  isRequired: '必填',
  selectAll: '全选'
};
export default messages;